import { useState, useRef, useEffect, useCallback } from 'react';
import {
	useNotification,
	useSocketMessages,
	createSocket,
	useHistory,
	useBlurAndAbove,
	useLoading,
	useGlobalAudio,
	handleAuto,
	stakeChecker,
	addMouseFlow
} from "@orbital/games-frontend-library"

import { MessagesList } from './lib/plinko_msg';
import { usePages } from './lib/pages';
import { helperAutoConfigs } from './handlers/handleAutoConfigs';
import { helperAudio } from './helper/handleAudio';
import { helperFinish } from './helper/helperFinish';
import { helperSendBet } from './senders/sendBet';
import { helperSendSettings } from './senders/sendSettings';
import { detectCoeff } from './helper/detectCoeff';
import { helperReceiveSettings } from './helper/receiveSettings';
import {
	defaultAudio,
	defaultAutoConfigs,
	defaultGameInfo,
	defaultBetInfo,
	defaultSeeds
} from './helper/defaultValues';
// import useSenders from "./senders/useSenders"; //TODO remove whole file
import Plinko from './plinko';
import { sumNumberSafe } from './helper/sumNumberSafe';

const App = () => {
  const WS_URL = '{{SERVER_WS_URL}}'
  const name = 'orbital.plinko'
  const wsbridge = 'wsbridge/v1/game'
  // const environment = 'test';
  const balanceUpdateOn = 'now'
  const autorollLogic = useRef<any>(null)
  const enableLoading = window.location.hostname !== 'localhost'
  useEffect(() => addMouseFlow(), [])

	const [isAutoOn, setisAutoOn] = useState(false);
	const [lastBetId, setlastBetId] = useState('');
	const [betCount, setbetCount] = useState(0);
	const [stake, setstake] = useState('');
	const [lastStake, setlastStake] = useState(stake);
	const handleStake = (s: string) => {
		setstake(s);
	};

	const [audio, setaudio] = useState(defaultAudio);
	const handleAudio = (s: any) => helperAudio(s, stake, setaudio, sendSettings);
	const [autoConfigs, setautoConfigs] = useState(defaultAutoConfigs);

	useEffect(() => {
		console.log('%cV2.0.6 DG', 'background: green; font-size: 16px');
	}, []);

	const handleAutoConfigs = (configs: any, bet: string) => {
		if (+ballBalance > 0) {
			if (stakeChecker(bet, maxBet, minBet, ballBalance, handleNotification)) {
				helperAutoConfigs(
					configs,
					bet,
					setautoConfigs,
					autorollLogic,
					gameInfo,
					setisAutoOn,
					betHandler
				);
			}
		} else {
			if (
				stakeChecker(bet, maxBet, minBet, gameInfo.balance, handleNotification)
			) {
				helperAutoConfigs(
					configs,
					bet,
					setautoConfigs,
					autorollLogic,
					gameInfo,
					setisAutoOn,
					betHandler
				);
			}
		}
		handleAbove(false);

		if (configs.numberOfBets !== autoConfigs.numberOfBets) {
			sendSettings(undefined, undefined, configs);
		}
	};

	const [gameInfo, setgameInfo] = useState(defaultGameInfo);
	const [betInfo, setbetInfo] = useState(defaultBetInfo);
	const [betSent, setBetSent] = useState(false);

	const [seeds, setSeeds] = useState(defaultSeeds);
	const [betReply, setBetReply] = useState({});

	const { user_id, maxBet, minBet, precision, balance } = gameInfo;
	const [history, addInHistory] = useHistory(user_id);

	const [blur, unBlur, settingsUnblur, above, handleAbove] = useBlurAndAbove();

	const pages = usePages(enableLoading);
	const [isLoaded, setisLoaded] = useState(false);
	const [arePagesLoaded, duration] = useLoading(handleAbove, pages);
	useEffect(() => {
		setisLoaded(arePagesLoaded && !!gameInfo.user_id);
	}, [arePagesLoaded, gameInfo.user_id, setisLoaded]);

	const receiveSettings = (obj: string) => {
		helperReceiveSettings(
			obj,
			setstake,
			setlastStake,
			setautoConfigs,
			setaudio
		);
	};

	const [errorText, seterrorText] = useState<string | boolean>(false);
	const handleErrorText = (text: string) =>
		seterrorText((errorText) => (errorText ? errorText : text));

	const [notification, handleNotification, notificationfadeOut] =
		useNotification();

	const [error, setErrorCode] = useState<number>(0);

	const socket = useRef<any>(null);
	const [setStatus, receiveMessage, sendMessage, sender] = useSocketMessages({
		socket,
		MessagesList,
		setbetInfo,
		setgameInfo,
		addInHistory,
		setSeeds,
		handleErrorText,
		receiveSettings,
		setBetReply,
		handleNotification,
		setErrorCode
	});
	useEffect(() => {
		if (!socket.current)
			createSocket(
				socket,
				receiveMessage,
				setStatus,
				WS_URL,
				name,
				wsbridge
				// 'wss://demo.orbitalgaming.com/websocketbridge/ws/plinko'
			);
	}, [socket, receiveMessage, setStatus]);

	useEffect(() => {
		error && setballsOnBoard((b: number) => b - 1);
		setTimeout(() => {
			setErrorCode(0);
		}, 200);
	}, [error]);

	const [activeRows, setActiveRows] = useState('8');
	const selectRows = (r: any) => setActiveRows(r.target.innerText);

	const [activeRisk, setActiveRisk] = useState('MEDIUM');
	const selectRisk = (r: any) => setActiveRisk(r.target.innerText);

	const [path, setPath] = useState<any>([]);
	const [ballBalance] = useState<any>('');
	const [finalBalance, setfinalBalance] = useState(0);
	const [ballsOnBoard, setballsOnBoard] = useState(0);

	useEffect(() => {
		setfinalBalance(parseFloat(gameInfo.balance));
	}, [gameInfo]);

	useEffect(() => {
		if (ballsOnBoard === 0) {
			betInfo.balance
				? setfinalBalance(parseFloat(betInfo.balance))
				: setfinalBalance(parseFloat(gameInfo.balance));
		}
	}, [ballsOnBoard, betInfo, notification, gameInfo]);

	useEffect(() => {
		setPath(betInfo.rolled);
	}, [betInfo.rolled, betInfo.balance]);

	useEffect(() => {
		setBetSent(false);
	}, [betInfo, notification]);

	const { sendBet, requestBetReply, seedRequest, newSeedRequest } = sender;

	useEffect(() => {
		const newStake = Number(gameInfo.minBet)
			.toFixed(gameInfo.precision)
			.toString();
		if (stake === '' || +stake === 0 || +stake < +newStake)
			return setstake(newStake);
	}, [stake, gameInfo]);

	const sendSettings = useCallback(
		(
			stakeFromSettings?: string,
			audioFromSettings?: any,
			autoFromSettings?: any
		) => {
			helperSendSettings(
				stake,
				audio,
				autoConfigs,
				sendMessage,
				stakeFromSettings,
				audioFromSettings,
				autoFromSettings
			);
		},
		[audio, autoConfigs, sendMessage, stake]
	);

	const [updateBalance, setUpdateBalance] = useState(false);

	useEffect(() => {
		betInfo.balance &&
			setfinalBalance((state) => {
				let balance;
				if (updateBalance) {
					setUpdateBalance(false);

					balance = sumNumberSafe(state, -betInfo.winAmount);
				} else {
					balance = sumNumberSafe(state, -parseFloat(stake as string));
				}
				return balance;
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [betInfo]);

	useEffect(() => {
		if (notification) {
			setUpdateBalance(true);
		}
	}, [notification]);

	const betHandler = useCallback(
		(stake) => {
			if (finalBalance >= Number(stake) && !betSent) {
				helperSendBet(
					stake,
					handleStake,
					sendBet,
					maxBet,
					minBet,
					balance,
					handleNotification,
					activeRisk,
					activeRows,
					setballsOnBoard,
					sendSettings,
					lastStake,
					setlastStake,
					setisAutoOn,
					setfinalBalance,
					setBetSent
				);
			} else {
				setlastBetId('');
				ballsOnBoard === 0 &&
					stakeChecker(
						stake,
						maxBet,
						minBet,
						finalBalance - +stake,
						handleNotification
					);
			}
		},
		[
			lastStake,
			maxBet,
			minBet,
			balance,
			activeRisk,
			activeRows,
			handleNotification,
			sendBet,
			sendSettings,
			finalBalance,
			ballsOnBoard,
			betSent
		]
	);

	const myTimeout = useRef<any>(null);
	const stopAuto = useCallback(() => {
		setisAutoOn(false);
		setbetCount(0);
		clearTimeout(myTimeout.current);
	}, []);

	useEffect(() => {
		if (notification) {
			stopAuto();
			return;
		}
		if (
			isAutoOn &&
			!betSent &&
			(+finalBalance >= +stake || ballsOnBoard === 0)
		) {
			if (lastBetId !== betInfo.bet_id) {
				setlastBetId(betInfo.bet_id);
				const { winAmount, betAmount, balance } = betInfo;
				myTimeout.current = setTimeout(function () {
					handleAuto(
						autorollLogic.current,
						winAmount,
						betAmount,
						balance,
						betHandler,
						handleNotification,
						precision,
						gameInfo.currency,
						gameInfo.maxBet,
						stopAuto
					);
				}, 200);
				setbetCount((b) => b + 1);
			}
		}
	}, [
		autorollLogic,
		betInfo,
		isAutoOn,
		gameInfo.currency,
		gameInfo.maxBet,
		betHandler,
		lastBetId,
		handleNotification,
		// betCount,
		stopAuto,
		precision,
		notification,
		finalBalance,
		stake,
		// betWasSent,
		ballsOnBoard,
		betSent
	]);

	const [roundId, setRoundId] = useState<string>('');

	const [coeffs, setcoeffs] = useState<[]>([]);
	useEffect(() => {
		detectCoeff(gameInfo.coeffs, activeRows, activeRisk, setcoeffs);
	}, [gameInfo.coeffs, activeRows, activeRisk]);

	const [isFinished, setisFinished] = useState(false);
	const handleFinish = (a: string, b: string) =>
		helperFinish(
			a,
			b,
			setisFinished,
			setballsOnBoard,
			setfinalBalance,
			setwheelCoefs,
			audio.sound
		);

	const [speed, setspeed] = useState(1);
	const toggleSpeed = () => setspeed((s) => (s === 1 ? 2 : 1));
	const [wheelCoefs, setwheelCoefs] = useState([]);
	const SFXS = useGlobalAudio(audio.volume, audio.sound);

	return (
		<Plinko
			balanceUpdateOn={balanceUpdateOn}
			stake={stake}
			handleStake={handleStake}
			finalBalance={finalBalance}
			gameInfo={gameInfo}
			audio={audio}
			SFXS={SFXS}
			handleAudio={handleAudio}
			handleAbove={handleAbove}
			handleAutoConfigs={handleAutoConfigs}
			seeds={seeds}
			toggleSpeed={toggleSpeed}
			betReply={betReply}
			history={history}
			blur={blur}
			unBlur={unBlur}
			settingsUnblur={settingsUnblur}
			above={above}
			isLoaded={isLoaded}
			errorText={errorText}
			notification={notification}
			notificationfadeOut={notificationfadeOut}
			speed={speed}
			isFinished={isFinished}
			path={path}
			ballBalance={ballBalance}
			winBalance={betInfo.winAmount}
			activeRows={activeRows}
			activeRisk={activeRisk}
			coeffs={coeffs}
			handleFinish={handleFinish}
			wheelCoefs={wheelCoefs}
			ballsOnBoard={ballsOnBoard}
			handleNotification={handleNotification}
			isAutoOn={isAutoOn}
			betHandler={betHandler}
			stopAuto={stopAuto}
			betCount={betCount}
			numberOfBets={+autoConfigs.numberOfBets}
			selectRisk={selectRisk}
			selectRows={selectRows}
			seedRequest={seedRequest}
			newSeedRequest={newSeedRequest}
			precision={precision}
			user_id={user_id}
			requestBetReply={requestBetReply}
			roundId={roundId}
			setRoundId={setRoundId}
			autoConfigs={autoConfigs}
			// audioError={AUDIO.error}
			// audioNotification={AUDIO.notification}
			enableLoading={enableLoading}
			duration={duration}
			betSent={betSent}
		/>
	);
};

export default App;
